// Nút giữ (UI_SPEC §13): hành động có trọng lượng nổ sau 720ms giữ, vòng nạp chạy quanh gạch chân.
// Chạm trơn thì nhãn cử chỉ chớp 2 lần để nhắc phải giữ (không im lặng). Bàn phím: giữ Enter / Space.
import type { ComponentChildren, JSX } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

export const HOLD_MS = 720;

export function HoldButton(props: {
  onHold: () => void;
  id?: string;
  disabled?: boolean;
  hint: string;
  children: ComponentChildren;
}): JSX.Element {
  const [holding, setHolding] = useState(false);
  const [hint, setHint] = useState(0);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  const start = (): void => {
    if (props.disabled || timer.current) return;
    setHolding(true);
    timer.current = setTimeout(() => {
      timer.current = null;
      setHolding(false);
      props.onHold();
    }, HOLD_MS);
  };
  const stop = (released: boolean): void => {
    if (!timer.current) return;
    clearTimeout(timer.current);
    timer.current = null;
    setHolding(false);
    if (released) setHint((h) => h + 1);
  };

  return (
    <span class="ht-hold">
      <button
        type="button"
        class={holding ? 'ht-textbtn holding' : 'ht-textbtn'}
        data-id={props.id}
        disabled={props.disabled}
        aria-label={`${typeof props.children === 'string' ? props.children : ''} (${props.hint})`}
        style={{ '--hold-ms': `${HOLD_MS}ms` }}
        onPointerDown={(e) => {
          (e.currentTarget as HTMLElement).setPointerCapture?.(e.pointerId);
          start();
        }}
        onPointerUp={() => stop(true)}
        onPointerCancel={() => stop(false)}
        onKeyDown={(e) => {
          if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
            e.preventDefault();
            start();
          }
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.key === ' ') stop(true);
        }}
        onClick={(e) => e.preventDefault()}
      >
        {props.children}
      </button>
      <small class="ht-hold-hint" key={hint} data-flash={hint > 0 ? '1' : undefined}>
        {props.hint}
      </small>
    </span>
  );
}
